import React from 'react';
import { Box, Typography, Card, CardContent, Avatar, Chip } from '@mui/material';

const StatCard = ({
                      title,
                      value,
                      suffix = '',
                      icon,
                      iconBgColor,
                      trendIcon = null,
                      trendText = '',
                      details = [],
                      chip = null
                  }) => {
    return (
        <Card sx={{ borderRadius: '10px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <CardContent sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box>
                        <Typography variant="subtitle2" color="textSecondary">{title}</Typography>
                        <Typography variant="h4" sx={{ mt: 1, fontWeight: 600 }}>
                            {value}
                            {suffix && (
                                <Typography component="span" variant="body1" sx={{ ml: 1 }}>
                                    {suffix}
                                </Typography>
                            )}
                        </Typography>

                        {trendIcon && trendText && (
                            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                {trendIcon}
                                <Typography variant="caption" sx={{ ml: 0.5 }}>
                                    {trendText}
                                </Typography>
                            </Box>
                        )}

                        {details.map((detail, index) => (
                            <Box
                                key={index}
                                sx={{
                                    // display: 'flex',
                                    alignItems: 'center',
                                    mt: index === 0 && !trendIcon ? 1 : 0,
                                    mr: index !== details.length - 1 ? 2 : 0,
                                    display: 'inline-flex'
                                }}
                            >
                                {detail.icon ? (
                                    detail.icon
                                ) : (
                                    <Box sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: '50%',
                                        bgcolor: detail.color,
                                        mr: 0.5
                                    }} />
                                )}
                                <Typography variant="caption" sx={{ ml: detail.icon ? 0.5 : 0 }}>
                                    {detail.text}
                                </Typography>
                            </Box>
                        ))}

                        {chip && (
                            <Chip
                                label={chip.label}
                                size="small"
                                sx={{
                                    ml: 1,
                                    height: 20,
                                    fontSize: '0.625rem',
                                    bgcolor: chip.bgColor,
                                    color: chip.color
                                }}
                            />
                        )}
                    </Box>
                    <Avatar sx={{ bgcolor: iconBgColor, width: 40, height: 40 }}>
                        {icon}
                    </Avatar>
                </Box>
            </CardContent>
        </Card>
    );
};

export default StatCard;